/* @ngInject */

export default ($timeout) => {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      country: '@',
      countries: '='
    },
    link(scope, element, attrs, ctrl) {
      $timeout(() => {
        if (attrs.country !== '') {
          const code = _.filter(
            scope.countries,
            (c) => c.name && c.name.common === attrs.country
          )[0];
          const prefix = code !== undefined ? code.callingCode[0] : '';

          const domElement = element[0];
          if (domElement.value === '') {
            ctrl.$setViewValue(prefix);

            domElement.value = prefix;
            const $e = angular.element(domElement);
            $e.triggerHandler('input');
          }
        }
      });
    }
  };
};
